module.exports = __webpack_public_path__ + "static/img/4.079adfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4.jpg
// module id = poA4
// module chunks = 0